// TODO: Coralogix cleanup - This entire file can be removed once migration to BetterStack is complete
import superagent from 'superagent';
import * as config from '../commons/config';

export enum Severity {
    debug = 1,
    verbose = 2,
    info = 3,
    warning = 4,
    error = 5,
    critical = 6,
}

export interface CoralogixLoggerOptions {
    applicationName: string;
    subsystemName: string;
    flushIntervalMs?: number;
    maxBufferedLogsCount?: number;
}

export interface CoralogixLog {
    severity: Severity;
    text: string;
    timestamp?: number;
    hiResTimestamp?: number;
    className?: string;
    category?: string;
    methodName?: string;
    threadId?: string;
}

export class CoralogixLogger {
    private url: string;
    private token: string;
    private applicationName: string;
    private subsystemName: string;
    private flushIntervalMs: number;
    private maxBufferedLogsCount: number;
    private logs: CoralogixLog[] = [];
    private interval: NodeJS.Timeout;
    private proxy?: string;

    constructor(options: CoralogixLoggerOptions) {
        this.url = process.env.CORALOGIX_URL || 'https://ingress.coralogix.com/logs/v1/bulk';
        this.token = config.CORALOGIX_PRIVATE_KEY;
        this.applicationName = options.applicationName;
        this.subsystemName = options.subsystemName;
        this.flushIntervalMs = options.flushIntervalMs || 2000;
        this.maxBufferedLogsCount = options.maxBufferedLogsCount || 50;
        this.interval = setInterval(() => this.flushLogs(), this.flushIntervalMs);
    }

    addLog(log: CoralogixLog): void {
        this.logs.push(log);
        if (this.logs.length >= this.maxBufferedLogsCount) this.flushLogs();
    }

    setProxy(proxy: string): void {
        this.proxy = proxy;
    }

    async waitForFlush(): Promise<void> {
        clearInterval(this.interval);
        await this.flushLogs();
    }

    private async flushLogs(): Promise<void> {
        try {
            if (this.logs.length === 0) return;

            const body = {
                applicationName: this.applicationName,
                subsystemName: this.subsystemName,
                logEntries: [...this.logs],
            };

            this.logs = [];

            const request = superagent
                .post(this.url)
                .set('Content-Type', 'application/json; charset=UTF-8')
                .set('Authorization', `Bearer ${this.token}`)
                .send(body);

            if (this.proxy) request.proxy(this.proxy);
            await request;
        } catch { /* a logger should never throw or crash the process */ }
    }
}
